import styled from "@emotion/styled";
import { Col, Input, Modal, Row } from "antd";
import "antd/dist/antd.css";
import React, { useState } from "react";
import { ModalLayout } from "../LayoutModals";
import { BlueButton } from "./BlueButton";
// Modal for changing the password

const handleSubmit = (e: Event) => {
  e.preventDefault();
};

const PopupButton = (): JSX.Element => {
  const [isVisible, setIsVisible] = useState(false);

  const showModal = () => {
    setIsVisible(true);
  };

  const handleOk = () => {
    setIsVisible(false);
  };

  const handleCancel = () => {
    setIsVisible(false);
  };

  return (
    <div>
      <BlueButton type="primary" onClick={showModal}>
        Bearbeiten
      </BlueButton>
      <Modal visible={isVisible} onOk={handleOk} onCancel={handleCancel}>
        <Row>
          <Col>
            <p style={{ fontSize: "16px", margin: 0 }}>
              <strong>Passwort ändern</strong>
            </p>
            <p style={{}}>
              Du kannst dein Passwort für deinen Account hier jederzeit ändern.
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <p style={{ marginBottom: "5px" }}>
              <strong>Passwort</strong>
            </p>
            <Input type="Password" placeholder="Passwort" />
            <p style={{ marginTop: "15px", marginBottom: "5px" }}>
              <strong>Neues Passwort</strong>
            </p>
            <Input type="Password" placeholder=" Neues Passwort" />
            <p style={{ marginTop: "15px", marginBottom: "5px" }}>
              <strong>Passwort bestätigen</strong>
            </p>
            <Input type="Password" placeholder="Passwort bestätigen" />
            <ModalLayout handleSubmit={handleSubmit} />
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export const ModalButtonPassword = styled(({ children, ...props }) => (
  <PopupButton {...props}>{children}</PopupButton>
))({});
